import { TestIdDomain } from 'constants/testIds';

const LoanHeadersTestIdsScope = {
  ASSOCIATE_REPORT_FORM: 'associate-report-form',
  LOAN_INFO_HEADER: 'loan-info-header',
};

export const LoanHeadersTestIds = {
  // AssociateReportForm
  ASSOCIATE_REPORT_FORM: 'associate-report.form',
  ASSOCIATE_REPORT_FORM_OPTION_SELECT: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.option-select`,

  // AusFindings
  ASSOCIATE_REPORT_FORM_HISTORICAL_RESULTS_SELECT: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.historical-results-select`,

  // ConfirmationPreSubmitModal
  WAREHOUSE_FORM: 'warehouse.form',

  // HeaderViewList
  ASSOCIATE_REPORT_FORM_LOAN_INFO_HEADER_KEY_LABEL: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.loan-info-header-key-label`,
  LOAN_APPLICATION_MAIN_HEADER_CONTENT: 'loan-application-main-header.content',

  // LoanInfoHeader
  ASSOCIATE_REPORT_FORM_LOAN_INFO_HEADER: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.${LoanHeadersTestIdsScope.LOAN_INFO_HEADER}`,
  LOAN_INFO_HEADER_COPY_LOAN_BUTTON: `${LoanHeadersTestIdsScope.LOAN_INFO_HEADER}.copy-loan-button`,

  // SendDisclosuresForm
  ASSOCIATE_REPORT_FORM_LOAN_HEADER_CANCEL_BUTTON: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.loan-header-cancel-button`,
  ASSOCIATE_REPORT_FORM_LOAN_HEADER_SUBMIT_BUTTON: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.loan-header-submit-button`,

  // Dynamic
  getLoanInfoHeaderItemId: id => `${LoanHeadersTestIdsScope.LOAN_INFO_HEADER}.item-${id}`,
  getLoanInfoHeaderItemValueId: formattedValue =>
    `${LoanHeadersTestIdsScope.LOAN_INFO_HEADER}.item-value-${formattedValue}`,

  // FannieLenderForm (inline)
  ASSOCIATE_REPORT_FORM_STATE_INPUT: `${LoanHeadersTestIdsScope.ASSOCIATE_REPORT_FORM}.state-input`,

  // DenialReasonFieldsSection (inline)
  ADD_DENIAL_REASONS_ITEM_BUTTON: `${TestIdDomain.LOAN_HEADERS}.add-denial-reasons-item-button`,
};
